!(function () {
  // sessionStorage.length || localStorage.setItem("getSessionStorage", Date.now()),
  //     window.addEventListener("storage", function (e) {
  //     if ("getSessionStorage" == e.key)
  //         localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage)),
  //         localStorage.removeItem("sessionStorage");
  //     else if ("sessionStorage" == e.key && !sessionStorage.length) {
  //         var t = [];
  //         for (var s in e.newValue && (t = JSON.parse(e.newValue)), t) sessionStorage.setItem(s, t[s])
  //     }
  // });

  try {
    new Swiper(".mySwiper", {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 30,
      mousewheel: !0,
      loop: !0,
      autoplay: { delay: 3e3, disableOnInteraction: !1 },
    });
  } catch (e) {}

  // window.addEventListener("load", function () {
    // document
    //     .getElementById("redirect_close")
    //     .addEventListener("click", function () {
    //       try {
    //         document
    //             .getElementById("redirect-bar_first-step")
    //             .classList.add("dn"),
    //             document
    //                 .getElementById("redirect-bar_second-step")
    //                 .classList.add("active");
    //       } catch (e) {}
    //     }),
    //     document
    //         .getElementById("redirect-bar_close")
    //         .addEventListener("click", function () {
    //           try {
    //             sessionStorage.setItem("topbar-modal", "close"),
    //                 // document.getElementById("redirect_bar").classList.remove("db");
    //                 sessionStorage.setItem('topbar-modal', 'close');
    // $(this).parents('modal-dialog')[0].hide()
    //           } catch (e) {}
    //         });
  // });
})();

function updateCountdown(n, e) {
  if (e[n]?.targetDate){
      let t = e[n],
          a = new Date(t.targetDate).getTime() - new Date().getTime(),
          o = Math.floor(a / 864e5),
          s = Math.floor((a % 864e5) / 36e5),
          _ = Math.floor((a % 36e5) / 6e4),
          c = Math.floor((a % 6e4) / 1e3);
      (document.getElementById(
          "countdown" + t.index
      ).innerHTML = `\n          <span class="count-down__item">\n            <span class="count-down__item__time">${
          (o < 10 ? "0" : "") + o
      }</span>d\n          </span>\n          <span class="count-down__item">\n            <span class="count-down__item__time">${
          (s < 10 ? "0" : "") + s
      }</span>h\n          </span>\n          <span class="count-down__item">\n            <span class="count-down__item__time">${
          (_ < 10 ? "0" : "") + _
      }</span>m\n          </span>\n          <span class="count-down__item">\n            <span class="count-down__item__time">${
          (c < 10 ? "0" : "") + c
      }</span>s\n          </span>\n        `),
      a <= 0 && (document.getElementById("countdown" + t.index).innerHTML = "");
  }
}
